import ArchiveLayout from '@/layouts/ArchiveLayout';
import { TOOLS_QUERY } from '@/lib/wordpress';

type Locale = 'en' | 'el';

const title: Record<Locale, string> = {
  en: 'Tools',
  el: 'Εργαλεία',
};

const description: Record<Locale, string> = {
  en: 'Useful tools and utilities to streamline your workflow.',
  el: 'Χρήσιμα εργαλεία και βοηθήματα για να βελτιστοποιήσετε τη ροή εργασίας σας.',
};

const eyebrow: Record<Locale, string> = {
  en: 'TOOLS',
  el: 'ΕΡΓΑΛΕΙΑ',
};

const emptyState: Record<Locale, string> = {
  en: 'No tools available at the moment.',
  el: 'Δεν υπάρχουν διαθέσιμα εργαλεία αυτή τη στιγμή.',
};

const ctaText: Record<Locale, string> = {
  en: 'Contact us',
  el: 'Επικοινωνήστε μαζί μας',
};

export default function ToolsArchive() {
  return (
    <ArchiveLayout
      pageKey="tools"
      postType="tools"
      query={TOOLS_QUERY}
      title={title}
      description={description}
      eyebrow={eyebrow}
      emptyState={emptyState}
      ctaText={ctaText}
    />
  );
}
